// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-item-label {
  font-weight: bolder;
}
.color-label {
  color: #337ab7;
}
.content-break {
  overflow-x: auto;
}
.last-row {
  color: #ff0000;
}
.wrap-a {
  display: block;
  word-break: break-all;
  width: 95%;
}
.row-border {
  border-bottom: 1px solid #eee;
}
.row-border .complaint-detail-label {
  margin: 8px 0 0 0;
}
.steps {
  margin-top: 10px;
  padding: 0px 20px;
}
.steps li {
  display: inline-block;
  padding: 5px 10px;
  background-color: #d9edf7;
  font-size: 12px;
  color: #313131;
  margin-right: 50px;
  position: relative;
  margin-bottom: 5px;
}
.steps li span {
  display: block;
}
.steps li span.line-contact {
  position: absolute;
  top: 50%;
  left: -50px;
  width: 50px;
  text-align: center;
  border-bottom: 1px solid #ccc;
  transform: translateY(-50%);
}
.innner-operation-btns {
  display: inline-block;
  width: 100%;
  min-height: 30px;
  position: absolute;
  bottom: 34px;
  left: 0px;
  text-align: left;
  border: 1px solid #ebeef5;
  border-radius: 5px;
  background-color: #fff;
  z-index: 999;
}
.innner-operation-btns .inner-btns {
  padding: 8px;
  cursor: pointer;
}
.innner-operation-btns .inner-btns:hover {
  background-color: #ecf5ff;
  color: #409eff;
}
.operation-btns {
  display: flex;
}
.operation-btns li {
  list-style: none;
  flex: 1;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ClientList/HistoricalComplaintsDetails/index.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAEA;EACE,cAAA;AAAF;AAGA;EACE,gBAAA;AADF;AAIA;EACE,cAAA;AAFF;AAKA;EACE,cAAA;EACA,qBAAA;EACA,UAAA;AAHF;AAMA;EACE,6BAAA;AAJF;AAGA;EAII,iBAAA;AAJJ;AAQA;EACE,gBAAA;EACA,iBAAA;AANF;AAIA;EAKI,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AANJ;AANA;EAeM,cAAA;AANN;AATA;EAmBM,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,2BAAA;AAPN;AAYA;EAWE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AApBF;AADA;EAEI,YAAA;EACA,eAAA;AAEJ;AAAI;EACE,yBAAA;EACA,cAAA;AAEN;AAeA;EACE,aAAA;AAbF;AAYA;EAII,gBAAA;EACA,OAAA;EACA,kBAAA;AAbJ","sourcesContent":[".form-item-label {\n  font-weight: bolder;\n}\n\n.color-label {\n  color: #337ab7;\n}\n\n.content-break {\n  overflow-x: auto;\n}\n\n.last-row {\n  color: #ff0000;\n}\n\n.wrap-a {\n  display: block;\n  word-break: break-all;\n  width: 95%;\n}\n\n.row-border {\n  border-bottom: 1px solid #eee;\n\n  .complaint-detail-label {\n    margin: 8px 0 0 0;\n  }\n}\n\n.steps {\n  margin-top: 10px;\n  padding: 0px 20px;\n\n  li {\n    display: inline-block;\n    padding: 5px 10px;\n    background-color: #d9edf7;\n    font-size: 12px;\n    color: #313131;\n    margin-right: 50px;\n    position: relative;\n    margin-bottom: 5px;\n\n    span {\n      display: block;\n    }\n\n    span.line-contact {\n      position: absolute;\n      top: 50%;\n      left: -50px;\n      width: 50px;\n      text-align: center;\n      border-bottom: 1px solid #ccc;\n      transform: translateY(-50%);\n    }\n  }\n}\n\n.innner-operation-btns {\n  .inner-btns {\n    padding: 8px;\n    cursor: pointer;\n\n    &:hover {\n      background-color: #ecf5ff;\n      color: #409eff;\n    }\n  }\n\n  display: inline-block;\n  width: 100%;\n  min-height: 30px;\n  position: absolute;\n  bottom: 34px;\n  left: 0px;\n  text-align: left;\n  border: 1px solid #ebeef5;\n  border-radius: 5px;\n  background-color: #fff;\n  z-index: 999;\n}\n\n.operation-btns {\n  display: flex;\n\n  li {\n    list-style: none;\n    flex: 1;\n    position: relative;\n  }\n}\n\n@primary-color: #FABF00;@input-placeholder-color: #868686;@btn-primary-color: #454545;@checkbox-check-color: #454545;@checkbox-color: #E8AA0D;@radio-button-bg: #E8AA0D;@radio-button-checked-bg: #E8AA0D;@radio-button-color: #454545;@radio-button-active-color: #454545;@radio-solid-checked-color: #454545;@font-family: 'WenQuanYi Micro Hei', 'Micro Hei','Noto Sans CJK','Source Han Sans','Montserrat','Roboto','Lato','sans-serif';@btn-text-shadow: 0 0 0 rgba(0, 0, 0, 0);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
